import axios from 'axios';

const auth_api = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/usermanagement',
  // baseURL: 'http://localhost:4003',
  withCredentials: false
});

const center_api = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/centersetup',
  // baseURL: 'http://localhost:4005',

  withCredentials: false
});

const appointment_api = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/appointment',
  // baseURL: 'http://localhost:4000',
  withCredentials: false
});

const helpdeskApi = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/helpdesk',
  // baseURL: 'http://localhost:4009',
  withCredentials: false
});

const payment_api = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/payment',
  // baseURL: 'http://localhost:5001',
  withCredentials: false
});

// --- NEW: API Client for Parent Child Management micro service ---
// Running on port 4002
const parentchildApi = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/parentchild',
  // baseURL: 'http://localhost:4002',
});

// --- NEW: API Client for data Collection micro service ---
// Running on port 4006
const dataCollectionApi = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/datacollection',
  // baseURL: 'http://localhost:4008/',
});

const S3config = axios.create({
  // baseURL: 'http://localhost:4008/api/s3',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/datacollection/api/s3',
});

const Questionnair = axios.create({
  // baseURL: 'http://localhost:7000',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/questionnair',
});



// --- NEW: API Client for Center Workflow micro service ---
// Running on port 4006
const centerworkflowApi = axios.create({
  // baseURL: 'http://localhost:4006/',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/centerworkflow',
});

const reporting_api = axios.create({
  // baseURL: 'http://localhost:4008/',
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/reporting',
});

const Referal_doc = axios.create({
  baseURL: 'https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/referaldoc/',
  withCredentials: false
});




export default {
  auth_api,
  center_api,
  appointment_api,
  helpdeskApi,
  payment_api,
  parentchildApi,
  dataCollectionApi,
  centerworkflowApi,
  S3config,
  reporting_api,
  Questionnair,
  Referal_doc,

};